import React from 'react'
import { Modal } from 'react-bootstrap'
import parse from 'html-react-parser'
import LessonVideo from '../lessons/LessonVideo'

const ModalVideoPreview = ({
  title,
  onClose,
  showVideo,
  videoUrl,
  captionsUrl,
  muxStreamId,
  courseId
}) => {
  return (
    <Modal
      show={showVideo}
      onHide={onClose}
      dialogClassName='modal-course-preview mobile-hidden'
    >
      <Modal.Header closeButton>
        <Modal.Title>{`${parse(title)} Introduction Video`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LessonVideo
          video={{
            id: 0,
            acf_extended: {
              video_url: videoUrl,
              captions_url: captionsUrl,
              mux_stream_id: muxStreamId
            }
          }}
          key={courseId}
        />
      </Modal.Body>
    </Modal>
  )
}

export default ModalVideoPreview
